import { useState, useCallback, useMemo } from 'react';
// @mui
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import Collapse from '@mui/material/Collapse';
import MenuItem from '@mui/material/MenuItem';
import TableRow from '@mui/material/TableRow';
import Checkbox from '@mui/material/Checkbox';
import TableCell from '@mui/material/TableCell';
import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// types
import { HTMenu } from 'src/types/api-response';
import { LoSam } from 'src/types/losam';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import { ConfirmDialog } from 'src/components/custom-dialog';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import { STATUS_OPTIONS } from 'src/constants/status';

// ----------------------------------------------------------------------

type Props = {
  row: LoSam;
  selected?: boolean; 
  onEditRow: VoidFunction;
  onViewRow: VoidFunction;
  onSelectRow?: VoidFunction;
  onDeleteRow: VoidFunction;
};

export default function LoSamTableRow({
  row,
  selected,
  onEditRow,
  onViewRow,
  onSelectRow,
  onDeleteRow,
}: Props) {
  const { tenLo, maLo, dienTich, loai, ghiChu, soHang, soCot, trangThai } = row;

  const confirm = useBoolean();
  // const collapse = useBoolean(); // Bỏ collapse
  const popover = usePopover();

  
  const statusColor = useMemo(() => {
      switch (trangThai) {
        case 1:
          return 'success';
        case 2:
          return 'warning';
        case 3:
          return 'error';
        default:
          return 'default';
      }
  }, [trangThai]);


  const renderPrimary = (
    <TableRow hover selected={selected}>
      {onSelectRow && (
        <TableCell padding="checkbox">
          <Checkbox checked={selected} onClick={onSelectRow} />
        </TableCell>
      )}

      <TableCell>
        <Box
          sx={{
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <ListItemText
            onClick={onEditRow}
            primary={tenLo}
            primaryTypographyProps={{ typography: 'body2', fontWeight: 'medium' }}
            secondary={maLo}
            secondaryTypographyProps={{
              typography: 'caption',
              color: 'text.disabled',
              component: 'span',
            }}
          />
        </Box>
      </TableCell>

      <TableCell>
        <Chip
          label={loai || '-'}
          variant="outlined"
          size="small"
          color="default"
        />
      </TableCell>
 <TableCell align="center">
        <Label color="info" variant="soft">
          {dienTich} m²
        </Label>
      </TableCell>
        <TableCell>
        <Box sx={{ maxWidth: 200 }}>
          <ListItemText
            primary={ghiChu || '-'}
            primaryTypographyProps={{
              typography: 'body2',
              color: 'text.secondary',
              noWrap: true,
            }}
          />
        </Box>
      </TableCell>
      <TableCell>
        <Chip
          label={`${soCot} x ${soHang}`}
          variant="outlined"
          size="small"
          color="primary"
        />
      </TableCell>

      <TableCell align="center">
        <Label
          variant="soft"
          color={statusColor} 
        >
          {STATUS_OPTIONS.find((o) => o.value === trangThai)?.label || '-'}
        </Label>
      </TableCell>

      <TableCell align="right" sx={{ px: 1, whiteSpace: 'nowrap' }}>
        <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
          <Iconify icon="eva:more-vertical-fill" />
        </IconButton>
      </TableCell>
    </TableRow>
  );

  return (
    <>
      {renderPrimary}

      <CustomPopover
        open={popover.open}
        onClose={popover.onClose}
        arrow="right-top" 
        sx={{ width: 140 }}
      >
        {/* Bỏ nút Xem như trong vuontrong-table-row.tsx */}
        {/* <MenuItem
          onClick={() => { 
            onViewRow();
            popover.onClose();
          }}
        >
          <Iconify icon="solar:eye-bold" />
          Xem
        </MenuItem> */}

        <MenuItem
          onClick={() => { 
            onEditRow();
            popover.onClose();
          }}
        >
          <Iconify icon="solar:pen-bold" />
          Sửa
        </MenuItem>

        {/* <MenuItem
          onClick={() => {
            confirm.onTrue(); 
            popover.onClose();
          }}
          sx={{ color: 'error.main' }}
        >
          <Iconify icon="solar:trash-bin-trash-bold" />
          Xóa
        </MenuItem> */}
      </CustomPopover>
{/* 
      <ConfirmDialog
        open={confirm.value}
        onClose={confirm.onFalse}
        title="Xóa lô sâm"
        content={`Bạn có chắc chắn muốn xóa lô sâm "${tenLo}"?`}
        action={
          <Button
            variant="contained"
            color="error"
            onClick={handleDelete} // Dùng handleDelete đã định nghĩa
          >
            Xóa
          </Button>
        }
      /> */}
    </>
  );
}